/**
 * Intended to be used to dynamically set Colors for Rechart elements using the
 * NAS theme. Loop through the array and start over again if you have more items.
 * @param index the index of color to return
 * @returns hexcode based on index
 */
export const getThemedColorCode = (index: number) => {
  const colorCodes = [
    "#00AF4A", // Default Green
    "#007A34",
    "#00461E",
    "#445bab", // Default Blue
    "#304078",
    "#697CBC",
    "#A652A0", // Default Purple
    "#743970",
    "#B875B3",
    "#ED7044", // Default Orange
    "#A64E30",
    "#F18D69",
  ];
  if (index > 12) {
    return colorCodes[index % 12];
  }
  return colorCodes[index];
};
